<template>
  <!-- Main Sidebar -->
  <a-layout-sider collapsible class="sider-primary" breakpoint="lg" collapsed-width="0" width="250px"
    :collapsed="sidebarCollapsed" @collapse="$emit('toggleSidebar', !sidebarCollapsed)" :trigger="null" :class="[
      'ant-layout-sider-' + sidebarColor,
      'ant-layout-sider-' + sidebarTheme,
    ]" theme="light" :style="{ backgroundColor: 'transparent' }">
    <div class="mt-0 text-center mb-10 brand">
      <!--  muicBrand.png -->
      <img style="margin-left: -35px;margin-top: -20px;height: 70px;" src="/images/muiclogoOf.png"
        alt="imag_DashboardSidebar_1" />
    </div>

    <!-- MSAL Profile Card -->
    <div v-if="msalAccount" class="msal-profile-card">
      <a-avatar :size="54" class="profile-avatar" style="background-color: #502B80">{{
        msalAccount.idTokenClaims.name.charAt(0) }}</a-avatar>
      <div class="profile-info">
        <div class="profile-name">{{ msalAccount.idTokenClaims.name }}</div>
        <div class="profile-email">{{ msalAccount.idTokenClaims.email }}</div>
      </div>
      <a-button type="dashed" size="small" class="profile-logout-btn" @click="handleLogout" icon="logout">
        Logout
      </a-button>
    </div>

    <!-- Sidebar Navigation Menu -->
    <a-menu theme="light" mode="inline">
      <a-menu-item v-if="checkRoleView(['faculty', 'staff', 'student'])">
        <router-link to="/dashboard">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="appstore" theme="outlined" />
          </span>
          <span class="label"> Portal </span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/calendar">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="calendar" theme="outlined" />
          </span>
          <span class="label">Calendar</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link
          v-if="['kitsana.chu', 'kanat', 'chanchai', 'anothai.sae', 'niwat.arm', 'patipan.wat', 'ponlapat.mun', 'rungtipa.sae', 'rungtipa.sae', 'threepak.pat'].includes(`${this.$store.state.role.RulesUser.username}`)"
          to="/chatmessage">
          <span class="icon">
            <a-avatar slot="avatar" shape="square" :size="25" src="/images/Khuncopter.png" />
          </span>
          <span class="label">AI Copter Group Test</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/chatmessage">
          <span class="icon">
            <a-avatar slot="avatar" shape="square" :size="25" src="/images/Khuncopter.png" />
          </span>
          <span class="label"><a-badge
              :number-style="{ marginTop: '-10px', marginRight: '-30px', color: '#ffffff', backgroundColor: '#693382', }"
              count="New Assistant!">AI Copter</a-badge></span>
        </router-link>
      </a-menu-item>
      <!-- document online -->
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/document-app">
          <span class="icon">
            <a-avatar slot="avatar" shape="square" :size="25" src="/imageApp/MUIC_APP_512_02.png" />
          </span>
          <span class="label">IC-APP</span>
        </router-link>
      </a-menu-item>
      <!-- 'student' -->
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/directory">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="phone" theme="outlined" />
          </span>
          <span class="label">Directory</span>
        </router-link>
      </a-menu-item>
      <!-- admin -->
      <a-menu-item v-if="checkRoleView(['adminRole'])">
        <a target="_blank" href="https://my.muic.io/admin#/mainadmincard">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="cluster" theme="outlined" />
          </span>
          <span class="label">
            IC Manage
          </span>
        </a>
      </a-menu-item>
      <!-- admin -->
      <a-menu-item class="menu-item-header"> Internal APP </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/hri">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="safety" theme="outlined" />
          </span>
          <span class="label">HRI</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff', 'student'])">
        <router-link to="/service">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="notification" theme="outlined" />
          </span>
          <span class="label">Service</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/teaching">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="audit" theme="outlined" />
          </span>
          <span class="label">Teaching record</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/booking">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="book" theme="outlined" />
          </span>
          <span class="label">Booking Systems</span>
        </router-link>
      </a-menu-item>
      <!-- parking -->
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/parking">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="car" theme="outlined" />
          </span>
          <span class="label">PARKING FEE STUDENT</span>
        </router-link>
      </a-menu-item>
      <!-- lost and found -->
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/lostandfound">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="search" theme="outlined" />
          </span>
          <span class="label">Lost and Found</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/tuitionpayment">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="qrcode" theme="outlined" />
          </span>
          <span class="label">Qr Payment</span>
        </router-link>
      </a-menu-item>
      <a-menu-item class="menu-item-header"> Personal Pages </a-menu-item>
      <!--  
        <a-menu-item v-if="checkRoleView(['staff'])">
          <router-link to="/profile-overview">
            <span class="icon">
              <a-icon style="margin-right: 1px" type="dashboard" theme="outlined" />
            </span>
            <span class="label">Check - IN</span>
          </router-link>
        </a-menu-item>
      -->
      <a-menu-item v-if="checkRoleView(['staff'])">
        <router-link to="/profile-overview">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="dashboard" theme="outlined" />
          </span>
          <span class="label">Overview</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff', 'student'])">
        <router-link to="/profile">
          <span class="icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
                fill="#111827" />
            </svg>
          </span>
          <span class="label">Profile</span>
        </router-link>
      </a-menu-item>
      <!-- hri menu -->
      <a-menu-item v-if="checkRoleView(['staff'])">
        <router-link to="/smartauthen">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="usergroup-add" theme="outlined" />
          </span>
          <span class="label">Smart Authen log</span>
        </router-link>
      </a-menu-item>
      <!-- hri menu -->
      <a-menu-item v-if="checkRoleView(['student'])">
        <a target="_blank" href="https://os.muic.io/">
          <span class="icon">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                clip-rule="evenodd" />
            </svg>
          </span>
          <span class="label">
            Schedule ( Open Section )
          </span>
        </a>
      </a-menu-item>
      <!-- sa -->
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/studentactivity">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="diff" theme="outlined" />
          </span>
          <span class="label">Student Activity</span>
        </router-link>
      </a-menu-item>
      <!-- sa -->
      <!--  
        <a-menu-item v-if="checkRoleView(['student'])" class="menu-item-header"> Other Pages </a-menu-item>
          <a-menu-item v-if="checkRoleView(['student'])">
            <a target="_blank" href="https://icapp.muic.mahidol.ac.th/lostandfound/std_login.php">
              <span class="icon">
                <a-icon style="margin-right: 1px" type="search" />
              </span>
              <span class="label">
                Lost and Found
              </span>
            </a>
          </a-menu-item>
      -->

    </a-menu>
    <!-- / Sidebar Navigation Menu -->
    <!-- / Sidebar Footer -->
    <br><br>
  </a-layout-sider>

  <!-- / Main Sidebar -->
</template>

<script>
import authService from '../../services/authService';

export default {
  props: {
    // Sidebar collapsed status.
    sidebarCollapsed: {
      type: Boolean,
      default: false,
    },

    // Main sidebar color.
    sidebarColor: {
      type: String,
      default: "primary",
    },

    // Main sidebar theme : light, white, dark.
    sidebarTheme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      msalAccount: null,
    };
  },
  mounted() {
    const msalData = localStorage.getItem('msalAccount');
    if (msalData) {
      try {
        this.msalAccount = JSON.parse(msalData);
      } catch (e) {
        console.error('Failed to parse MSAL account data', e);
      }
    }
  },
  computed: {},
  methods: {
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    checkRoleView(arrVal) {
      const { RulesUser } = this.$store.state.role;
      if (!RulesUser || RulesUser.length === 0) return false;

      return arrVal.some((role) =>
        role === 'adminRole'
          ? RulesUser.permissions && RulesUser.permissions.length !== 0
          : RulesUser.roles && RulesUser.roles.includes(role)
      );
    },
    async handleLogout() {
      // Priority 1: Check Keycloak
      if (this.$keycloak && this.$keycloak.authenticated) {
        if (globalThis._keycloak) {
          globalThis._keycloak.logout({
            redirectUri: globalThis.location.origin + '/login'
          });
        } else if (typeof this.$keycloak.logout === 'function') {
          this.$keycloak.logout({
            redirectUri: globalThis.location.origin + '/login'
          });
        } else {
          console.error("Keycloak logout method not found");
          // Fallback: manually redirect to logout endpoint if possible or just clear local state?
          // Keycloak session clearance requires redirect to IDP. 
          // Without logout method, we can try to guess the URL or just fail gracefully.
          // But window._keycloak should exist now.
        }
      } else {
        // Priority 2: MSAL
        try {
          await authService.logout();
        } catch (error) {
          console.error("MSAL logout failed", error);
        }
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-dashboard .ant-layout-sider.sider-primary .brand {
  padding: 0px 8px;
}

.filter-shadow {
  color: transparent;
  background: linear-gradient(183deg, #630fa2, #522c7f);
  background-clip: text;
  filter: drop-shadow(-1px -1px white) drop-shadow(1px 1px darken(white, 50%)) drop-shadow(1px 1px darken(white, 52%)) drop-shadow(1px 1px darken(white, 54%)) drop-shadow(1px 1px darken(white, 56%)) drop-shadow(1px 1px darken(white, 58%)) drop-shadow(1px 1px darken(white, 60%)) drop-shadow(1px 1px darken(white, 62%)) drop-shadow(1px 1px darken(white, 64%)) drop-shadow(1px 1px darken(white, 66%)) drop-shadow(1px 1px darken(white, 68%)) drop-shadow(1px 1px darken(white, 70%)) drop-shadow(12px 12px 30px rgba(black, 0.2)) drop-shadow(12px 12px 10px rgba(black, 0.2));
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-20px);
  }
}

.bouncing-box {
  width: 100px;
  height: 100px;
  background-color: orange;
  border-radius: 10px;
  animation: bounce 1s infinite ease-in-out;
}

.msal-profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  margin: 0 16px 16px 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  text-align: center;
}

.profile-avatar {
  margin-right: 0;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 20px;
}

.profile-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

.profile-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-email {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
}

.profile-logout-btn {
  width: 100%;
  color: #ff4d4f;
  border-color: #ffa39e;
}

.profile-logout-btn:hover {
  color: #ff7875;
  border-color: #ff7875;
}
</style>
